var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTailwindWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 495.256,
    height: 297.745,
    viewBox: "0 0 495.256 297.745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "tailwind-white",
    d: "M410.586,93.2a104.5,104.5,0,0,1-47.3-33.182A142.881,142.881,0,0,0,249.628,6.284a116.88,116.88,0,0,0-123.814,99.051,79.984,79.984,0,0,1,86.67-36.9,106.976,106.976,0,0,1,47.3,33.43,142.881,142.881,0,0,0,113.661,52.992A116.88,116.88,0,0,0,497.256,55.81,79.241,79.241,0,0,1,410.586,93.2ZM88.67,216.52a104.5,104.5,0,0,1,47.3,33.182,142.882,142.882,0,0,0,113.661,53.735,116.88,116.88,0,0,0,123.814-99.051,79.984,79.984,0,0,1-86.67,36.9,106.975,106.975,0,0,1-47.3-33.43,143.624,143.624,0,0,0-113.661-52.992A116.88,116.88,0,0,0,2,253.912,79.241,79.241,0,0,1,88.67,216.52Z",
    transform: "translate(-2 -5.988)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwindWhite);
export default __webpack_public_path__ + "static/media/tailwind-white.f8c94e4e41526a937b94d7c15a8e05d2.svg";
export { ForwardRef as ReactComponent };